import { render, staticRenderFns } from "./change-password-form.vue?vue&type=template&id=0f03162c&"
import script from "./change-password-form.vue?vue&type=script&lang=js&"
export * from "./change-password-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports